import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

/**
 * Facetas da busca de licitações (GET /licitacoes/meta).
 *
 * O servidor cacheia as facetas por 15 minutos; o staleTime aqui acompanha
 * esse TTL para não repetir a consulta a cada abertura do painel de filtros.
 */

export interface LicitacaoFaceta {
  valor: string;
  total: number;
}

/** Chaves em snake_case sem acento, como o backend devolve (ex.: `centro_oeste`). */
export type RegiaoKey = 'norte' | 'nordeste' | 'centro_oeste' | 'sudeste' | 'sul';

export type LicitacoesMetaRegioes = Record<string, string[]>;

export interface LicitacoesMeta {
  ufs: LicitacaoFaceta[];
  modalidades: LicitacaoFaceta[];
  portais: LicitacaoFaceta[];
  categorias: LicitacaoFaceta[];
  regioes: LicitacoesMetaRegioes;
  atualizadoEm: string;
}

interface LicitacoesMetaResponse {
  success: boolean;
  data: LicitacoesMeta;
}

export const LICITACOES_META_STALE_TIME = 15 * 60 * 1000;

export function useLicitacoesMeta(somenteAtivas = true) {
  return useQuery({
    queryKey: ['licitacoes-meta', somenteAtivas],
    queryFn: async () => {
      const response = await api.get<LicitacoesMetaResponse>('/licitacoes/meta', {
        params: { somente_ativas: somenteAtivas ? 'true' : 'false' },
      });
      return response.data;
    },
    staleTime: LICITACOES_META_STALE_TIME,
    retry: 1,
  });
}
